import { render, staticRenderFns } from "./ChromeWarning.vue?vue&type=template&id=875c830c&scoped=true"
import script from "./ChromeWarning.vue?vue&type=script&lang=js"
export * from "./ChromeWarning.vue?vue&type=script&lang=js"
import style0 from "./ChromeWarning.vue?vue&type=style&index=0&id=875c830c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875c830c",
  null
  
)

export default component.exports